<app-header></app-header>
<div class="sidebar-inner">
	<div class="container">
	    <div class="row">
	        <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12">
					<!-- <div class="sticky-bottom top-65">
					<app-profile-left *ngIf="fcs.device_detail.is_mobile!=true"></app-profile-left>
				</div> -->
					 <router-outlet></router-outlet>
			
			</div>
		</div>
		
	</div>
	</div>
	<app-nudges *ngIf="nudge_data?.nudge_data?.length>0" [nudge_data]="nudge_data?.nudge_data"></app-nudges>
